<template>
  <div>
    <div class="items-ct">
      <div class="item" v-for="item in data">
        <project-overview
          :project-id="item.id"
          :project-name="item.name"
          :project-icon="item.icon"
          :metrics="item.project_overview_metrics"
          :workflow="item.maxautomation"
          :project-status="item.project_status"
        />
      </div>
      <div
        v-if="data.length === 0"
        v-for="index in 2"
        :key="index"
        class="item"
      >
        <project-overview-placeholder />
      </div>
    </div>

    <el-pagination
      v-if="maxPages > 1"
      background
      class="paginator"
      :layout="paginationLayout"
      :page-count="maxPages"
      :current-page="currentPage"
      @current-change="pageChange"
    />
  </div>
</template>

<script>
import { RestApiPaginator } from '@/core/utils/RestApiPaginator'
import memoize from 'memoizee'
import ProjectOverview from '@/common/components/ProjectOverview'
import ProjectOverviewPlaceholder from '@/common/components/ProjectOverviewPlaceholder'
import { ProjectStatusEnum } from '@/common/enum/ProjectStatusEnum'

const fetchPage = memoize(
  (page, paginator, params) => paginator.fetchPage(page),
  {
    promise: true,
    maxAge: 10000
  }
)

export default {
  name: 'RestCards',

  components: { ProjectOverviewPlaceholder, ProjectOverview },

  props: {
    payload: {
      required: true,
      type: Object
    }
  },

  provide() {
    return {
      restTiles: this
    }
  },

  data() {
    return {
      data: [],
      paginator: {},
      maxPages: 1,
      currentPage: 1,
      paginationLayout: 'prev, pager, next',
      ProjectStatusEnum
    }
  },

  mounted() {
    this.paginator = new RestApiPaginator(this.payload)
    this.fetchPage(1)
  },

  methods: {
    async pageChange(val) {
      await this.fetchPage(val)
    },

    async fetchPage(page) {
      try {
        let response = await fetchPage(
          page,
          this.paginator,
          JSON.stringify(this.paginator.params)
        )
        this.maxPages = Number.parseInt(
          response.headers['x-pagination-page-count']
        )
        this.currentPage = Number.parseInt(
          response.headers['x-pagination-current-page']
        )

        this.paginationLayout =
          Number.parseInt(response.headers['x-pagination-total-count']) === -1
            ? 'prev, next'
            : 'prev, pager, next'

        this.data = response.data
      } catch (error) {
        this.data = null
        this.$message({
          message: error.message,
          type: 'error'
        })
      } finally {
        this.$emit('loaded-project-metrics', false)
        this.$emit('projects-data', this.data)
      }
    }
  }
}
</script>

<style scoped>
.items-ct {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
}

.item {
  margin-bottom: 20px;
}

.paginator {
  display: flex;
  justify-content: center;
  margin: 20px 0;
}

>>> .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #1d87c8;
}

>>> .el-pagination.is-background .btn-prev,
>>> .el-pagination.is-background .btn-next,
>>> .el-pagination.is-background .el-pager li {
  background-color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/common/components/rest/RestCards.vue